// Human-readable workspace label. The API returns workspace keys as
// `ko_global`, `red_bull_global`, etc. — turn them into "KO GLOBAL",
// "RED BULL MEWA" for display. Matches the transform used in the dashone web
// app's workspace switcher and the API's invitation-email helper, so staff see
// the same label everywhere. The raw key stays the identifier for search/copy.
export const humanizeWorkspaceKey = (key) =>
  typeof key === "string" ? key.replace(/_/g, " ").toUpperCase() : "";
